/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

interface IArrowRightIcon extends ComponentPropsWithoutRef<'svg'> {
  fill?: string;
}

function ArrowRightIcon({ fill = '#1D1D1D', ...props }: IArrowRightIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={33}
      fill="none"
      {...props}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="m17.627 1.832 14.24 14.212-14.24 14.211-2.825-2.831 9.4-9.38H.964v-4H24.2l-9.4-9.381 2.826-2.831Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default memo(ArrowRightIcon);
